import React, { useState, useEffect } from "react";
import { Progress ,Row, Col, Button,Divider} from 'antd';
import BackImg from "./../../../assets/BG4.jpg";
import TflBanner from "./../../../assets/EzyGo_Coins.png";
import icon1 from "./../../../assets/icon/1.png";
import icon2 from "./../../../assets/icon/2.png";
import icon3 from "./../../../assets/icon/3.png";
import Home from "./../../Home";
import { GETAllAPI, POSTAPI } from "../../Vendor/AllApi";
import appConfig from "../../../helpers/appConfig";
import "./tfl.css";
import io from "socket.io-client"; // ← Add this
import { socket } from "../../../utils/socketNew";
import { NavLink } from "react-router-dom";
const TflReport = (props) => {
  const [dailyData, setDailyData] = useState({});
  const [loading, setLoading] = useState(false);
  // optional: put your socket server URL here if it's different


  useEffect(() => {
    getDailyRecord();

    // ✅ Listen for "adminAddCoins" event
    socket.on("adminAddCoins", () => {
      console.log("adminAddCoins event received from server");
      getDailyRecord();
    });

    // // cleanup on unmount
    // return () => {   
    //   socket.off("adminAddCoins");
    // };
  }, []);


  const getDailyRecord = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "x-auth-token": token,
      };
        let resData = await GETAllAPI(`${appConfig.endpoint}/api/v1/employee/arkiv/branchCoins`,
          {
            headers: headers,
          }
        )
        setDailyData(resData.data)
        setLoading(false)
        console.log("=======", resData.data)
    } catch (error) {
        console.log(error)
    }
}

let availablePercent = 0;
let distributedPercent = 0;
let distributedPoints = Number(dailyData.totalPoints) - Number(dailyData.availablePoints); 

if (dailyData.totalPoints && dailyData.totalPoints > 0) {
  availablePercent = Number((dailyData.availablePoints / dailyData.totalPoints) * 100).toFixed(2);
  distributedPercent = Number((distributedPoints / dailyData.totalPoints) * 100).toFixed(2);
}

console.log("dailyData",dailyData)
  const goBackMainPage = () => {
    props.history.push("/arkiv");
  };

   // Function to handle "View Coins Detail" button click
   const handleViewCoinsDetail = () => {
    // Navigate to a new route for coin details, or open a modal, etc.
    // For example, navigate to a new page:
    props.history.push("/arkiv/coins-detail"); // Adjust this route as needed
  };


  return (
    <Home>
     <div className="report-container">
          <span className="item" style={{ width: "60%" }}>
           <span>Arkiv : </span> TFL Agent Coins
          </span>
          <span id="less-visible">
           <Button
               onClick={() => goBackMainPage()}
               className="ant-btn back-btn"
             >
              <i className="fa fa-arrow-circle-left" aria-hidden="true" />
           </Button>
          </span>
         </div>
  
         <Row className="d-flex justify-content-center">
      <Col span={14}>
        <Row  gutter={[8,0]} className="bg-white" style={{height:"100%", borderRadius:"10px",    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"}}>
         {/* NEW: Button placed on the top right */}
         <Col span={24} style={{ textAlign: 'right', padding: '10px' }}>
         <NavLink exact to="/arkiv/distributedCoins" activeClassName="is-active"
         style={{ textDecoration: 'underline', color: 'blue' }} 
         >
                View Coins Detail              
                <i className="fa fa-arrow-circle-right fa-lg pl-1" aria-hidden="true" />
              </NavLink>
            </Col>
        
      <Col span={24} className="flexColImg "  ><img src={icon1} width="100px"/><p className="fontSize-18">Total Coins</p>
      <p className="fontSize-25">{dailyData.totalPoints ? dailyData.totalPoints : 0}</p>
     </Col>
     
      <Col span={12} className="flexColImg pb-4 px-3"><Divider/><img src={icon2} width="100px"/><p className="fontSize-18">Coins Available</p>
      <p className="fontSize-25">{dailyData.availablePoints ? dailyData.availablePoints : 0}</p>
      <Progress percent={Number(availablePercent)} strokeColor="green" status="normal" /></Col>
      
      <Col span={12} className="flexColImg pb-4 px-3 "><Divider/><img src={icon3} width="100px"/><p className="fontSize-18">Coins Given</p>
      <p className="fontSize-25">{distributedPoints ? distributedPoints :0}
      </p>
      <Progress percent={Number(distributedPercent)} strokeColor="orange" status="normal" /></Col>
        </Row>
      </Col>
    </Row>
    </Home>
  );
};

export default TflReport;





// import React from "react";
// import { NavLink } from "react-router-dom";
// // import TflBanner from "./../../../assets/TFL_banner.png";
// import TflBanner from "./../../../assets/tfllogo (1).png";
// import "./tfl.css";
// import { Progress } from "antd";
// import { Card, Row, Col, Button, Image, Container } from "react-bootstrap";
// import Home from "./../../Home";
// const TflReport = (props) => {
//   let tflamount ;
//   tflamount = Number(localStorage.getItem("tflamount"))
//     ? Number(localStorage.getItem("tflamount"))
//     : 0;

//   /*---converting tfl point to progress bar --------*/
//   const perValue = (tflamount / 10000) * 100;
//   return (
//     <>
//       <Home>
//         <div className="report-container">
//           <span className="item ">
//             <span>Arkiv : </span> TFL Rapport
//             <NavLink to="/arkiv" className="btn back-btn">
//               <i className="fa fa-arrow-circle-left" aria-hidden="true" />
//             </NavLink>
//           </span>
//         </div>
//         <div className="p-5">
//           <Row className="justify-content-center py-3">
//             <img src={TflBanner} height="350px" />
//           </Row>

//           <Row className="pt-5">
//             <Progress percent={perValue} format={(percent) => `${tflamount} Points` } />
//           </Row>
//           <Row className="p-5 justify-content-center">
//             <h2 style={{ fontSize: "30px", fontWeight:"700" }}>
//               TFL POINTS: {`${tflamount}`}/ 10,000
//             </h2>
//           </Row>
//                 </div>
//                 {/* <Image
//                   src={TflBanner}
//                   alt="Tfl Banner"
//                   style={{ width: "100%" }}
              
//                 <Row className="text-center">
//                   <Col>
//                     {" "}
//                     {/* <h2 style={{ color: "green", fontWeight: "bold" }}>
//                       TFL POINTS:{`${tflamount}`}
//                     </h2> */}
//       </Home>
//     </>
//   );
// };

// export default TflReport;
